import {
  LikeOutlined,
  CommentOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { apiPHP } from '../../../../services/api';
import { formatDate } from '../../../../utils/formatDate';
import { Container, Content, Footer, Header } from './styles';

import defaultImg from '../../../../assets/img/logoWhite.png';

interface GameProps {
  id_jogo: number;
  id_dificuldade: number;
  titulo: string;
  subtitulo: string;
  created_at: string;
  edicoes_id?: number;
  id_tipo?: number;
  curtidas_count?: number;
  comentarios_count?: number;
}

interface CardProps {
  game: GameProps;
  sectionId?: number;
  openCommentsModal: (id: number) => void;
  updateGameSectionLikeCount: (
    operation: string,
    sectionId: number,
    gameId: number
  ) => void;
  navigateToTournaments?: () => void;
}

export const Card: React.FC<CardProps> = ({
  game,
  sectionId,
  navigateToTournaments,
  openCommentsModal,
  updateGameSectionLikeCount,
}: CardProps) => {
  const navigate = useNavigate();

  const handleToggleLike = async () => {
    try {
      await apiPHP
        .get(`/curtir/passatempos/${game.id_jogo}`)
        .then(() => {
          sectionId &&
            updateGameSectionLikeCount('like', sectionId, game.id_jogo);
        })
        .catch(async () => {
          await apiPHP.get(`/descurtir/passatempos/${game.id_jogo}`);
          sectionId &&
            updateGameSectionLikeCount('dislike', sectionId, game.id_jogo);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const navigateToGame = () => {
    switch (game.id_tipo) {
      case 3: {
        return navigate(`/jogo/palavrascruzadas/${game.id_jogo}`);
      }
      case 5: {
        return navigate(`/jogo/rebus/${game.id_jogo}`);
      }
      case 6: {
        return navigate(`/jogo/quiz/${game.id_jogo}`);
      }
      case 7: {
        return navigate(`/jogo/cacapalavras/${game.id_jogo}`);
      }
      case 8: {
        return navigate(`/jogo/sudoku/${game.id_jogo}`);
      }
    }
  };

  return (
    <Container>
      <Header level={game.id_dificuldade ? game.id_dificuldade : 2}>
        <p>
          {game.id_dificuldade
            ? game.id_dificuldade === 1
              ? 'Fácil'
              : game.id_dificuldade === 2
              ? 'Médio'
              : 'Difícil'
            : 'Médio'}
        </p>
        <div>
          <span>
            <LikeOutlined /> 10
          </span>
          <span>
            <CommentOutlined /> 15
          </span>
          {/* <span
            style={{
              display: game.curtidas_count !== undefined ? 'inline' : 'none',
            }}
          >
            <LikeOutlined /> {game.curtidas_count}
          </span>
          <span
            style={{
              display: game.comentarios_count !== undefined ? 'inline' : 'none',
            }}
          >
            <CommentOutlined /> {game.comentarios_count}
          </span> */}
        </div>
      </Header>

      <Content
        {...(navigateToTournaments !== undefined && {
          onClick: navigateToTournaments,
        })}
        {...(navigateToTournaments === undefined && {
          onClick: navigateToGame,
        })}
      >
        <span>
          <img src={defaultImg} alt={game.titulo} className="swiper-lazy" />
        </span>

        <div>
          <span>
            <h1>{game.titulo}</h1>
            <h2>{game.subtitulo === '.' ? '' : game.subtitulo}</h2>
          </span>
          <span>
            <h2>{formatDate(new Date(game.created_at))}</h2>
            <h2>{game.edicoes_id}</h2>
          </span>
        </div>
      </Content>

      <Footer>
        <button type="button" onClick={handleToggleLike}>
          <LikeOutlined />
        </button>
        <button type="button" onClick={() => openCommentsModal(game.id_jogo)}>
          <CommentOutlined />
        </button>
        {/* <button
          type="button"
          onClick={handleToggleLike}
          style={{
            display: game.curtidas_count !== undefined ? 'flex' : 'none',
          }}
        >
          <LikeOutlined />
        </button>
        <button
          type="button"
          onClick={() => openCommentsModal(game.id_jogo)}
          style={{
            display: game.comentarios_count !== undefined ? 'flex' : 'none',
          }}
        >
          <CommentOutlined />
        </button> */}
        <button
          type="button"
          onClick={
            navigateToTournaments !== undefined
              ? navigateToTournaments
              : navigateToGame
          }
        >
          <PlayCircleOutlined />
        </button>
      </Footer>
    </Container>
  );
};
